/*
 * Relatar problema: um botão flutuante para quem tem a permissão. Ele abre um
 * menu com "Relatar um problema nesta página" (marca a área, descreve e envia)
 * e "Meus relatórios" (o status e a resposta da equipe).
 *
 * O servidor manda `canelaBugReports` só para quem pode reportar; para os
 * demais o recurso nem se instala. A seleção, a captura (html-to-image) e os
 * modais ficam num chunk à parte, baixado no primeiro clique.
 *
 * Baseado no Bugframe (github.com/vmatheus3/bug-frame), MIT.
 */
import app from 'flarum/forum/app';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import { t } from '../../utils/settings';
import { installConsoleCapture, UI_ATTR } from './console';
const STORAGE_KEY = 'canela.bugs';
export const options = () => {
  const value = app.forum?.attribute('canelaBugReports');
  return value && typeof value === 'object' ? value : null;
};
const loadReporter = () => import(/* webpackChunkName: 'forum/features/bugreports/reporter', webpackMode: 'lazy-once' */ './reporter');
const read = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
const write = on => {
  try {
    if (on) localStorage.setItem(STORAGE_KEY, '1');else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Armazenamento bloqueado: a escolha só não fica guardada.
  }
};

/** `?bugs=1` liga o botão neste navegador (até `?bugs=0`), quando o admin não o deixa sempre à vista. */
function shownByQuery() {
  const value = new URLSearchParams(window.location.search).get('bugs');
  if (value === '1' || value === '0') write(value === '1');
  return read();
}
class BugButton {
  open = false;
  view() {
    const opts = options();
    if (!opts || !app.session.user) return null;
    if (!opts.button && !shownByQuery()) return null;
    return m("div", {
      className: classList('CanelaBugButton', {
        open: this.open
      })
    }, this.open && m("div", {
      className: "CanelaBugButton-menu",
      role: "menu"
    }, m("button", {
      type: "button",
      role: "menuitem",
      className: "CanelaBugButton-item",
      onclick: () => this.report()
    }, m(Icon, {
      name: "fas fa-crop-simple"
    }), t('bug_reports.menu_report')), m("button", {
      type: "button",
      role: "menuitem",
      className: "CanelaBugButton-item",
      onclick: () => this.mine()
    }, m(Icon, {
      name: "fas fa-list-check"
    }), t('bug_reports.menu_mine')), !opts.button && m("button", {
      type: "button",
      role: "menuitem",
      className: "CanelaBugButton-item",
      onclick: () => this.turnOff()
    }, m(Icon, {
      name: "fas fa-eye-slash"
    }), t('bug_reports.menu_off'))), m("button", {
      type: "button",
      className: "CanelaBugButton-toggle",
      "aria-haspopup": "menu",
      "aria-expanded": this.open ? 'true' : 'false',
      "aria-label": t('bug_reports.button'),
      title: t('bug_reports.button'),
      onclick: () => {
        this.open = !this.open;
        // Com o menu aberto, a captura já se prepara: o clique em "Relatar" fica instantâneo.
        if (this.open) loadReporter().then(chunk => chunk.warm());
      }
    }, m(Icon, {
      name: this.open ? 'fas fa-xmark' : 'fas fa-bug'
    })));
  }
  report() {
    this.open = false;
    loadReporter().then(chunk => chunk.startReport(options()));
  }
  mine() {
    this.open = false;
    loadReporter().then(chunk => chunk.showMyReports());
  }
  turnOff() {
    this.open = false;
    write(false);
  }
}
export default function installBugReports() {
  // No beforeMount o fórum e a sessão já existem.
  app.beforeMount(() => mountButton());
}
function mountButton() {
  // Sem a permissão (ou com o recurso desligado), nada a fazer.
  const opts = options();
  if (!opts) return;
  if (opts.console) installConsoleCapture();
  const root = document.createElement('div');
  root.setAttribute(UI_ATTR, '');
  root.className = 'CanelaBugRoot';
  document.body.appendChild(root);
  const button = new BugButton();
  m.mount(root, {
    view: () => button.view()
  });

  // Fecha o menu num clique fora dele.
  document.addEventListener('pointerdown', e => {
    if (button.open && !e.target?.closest?.('.CanelaBugButton')) {
      button.open = false;
      m.redraw();
    }
  }, true);
}
flarum.reg.add('ramon-canela', 'forum/features/bugreports', installBugReports);flarum.reg.addChunkModule('forum/features/bugreports/reporter', './src/forum/features/bugreports/reporter.tsx', 'ramon-canela', 'forum/features/bugreports/reporter');
flarum.reg.addChunkModule('forum/features/bugreports/reporter', './src/forum/features/bugreports/reporter.tsx', 'ramon-canela', 'forum/features/bugreports/context');
flarum.reg.addChunkModule('forum/features/bugreports/reporter', './src/forum/features/bugreports/reporter.tsx', 'ramon-canela', 'forum/features/bugreports/capture');